<template>
  <AsyncImage
    v-bind="$attrs"
    :src="getBadgeImage(badge, quality)"
    class="object-contain"
    :class="{
      'w-full h-full': size === 'fill',
      'h-16 w-16': size === 'large',
      'h-6 w-6': (!size && !sizeClass) || size === 'normal',
      'h-5 w-5': size === 'medium',
      'h-4 w-4': size === 'small',
      [sizeClass ?? '']: sizeClass,
    }"
  />
</template>

<script setup lang="ts">
import {
  type BadgeEntity,
  type BadgeRelation,
  getBadgeImage,
  type PopulateRelationship,
} from "~/src/api";

defineComponent({
  inheritAttrs: false,
});

defineProps<{
  badge: BadgeEntity | PopulateRelationship<BadgeRelation>;
  quality?: "128" | "256" | "512" | "original";
  size?: "normal" | "small" | "medium" | "large" | "fill";
  sizeClass?: string;
}>();
</script>
